import React, {useRef, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from 'reactstrap';

import {
    error,
    FORM,
    info,
    infoMsg,
    REQUIRED,
    saveMsg,
    success,
    updateMsg
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit, GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import {confGlobalService} from "../../../jwt/_services/configuration/confGlobalService";
import {showLoader} from "../../../components/loader/loader";
import {ErrorMessage, useForm} from "react-hook-form";
import * as Yup from "yup";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function ConfGlobalForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    const validationSchema = Yup.object().shape({
        userSivex: Yup.string().required(REQUIRED),
        passwordSivex: Yup.string().required(REQUIRED)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: savedData?.id,
            uid: savedData?.uid,
            cognitoUrl: savedData?.cognitoUrl,
            datamapAndroid: savedData?.datamapAndroid,
            datamapIos: savedData?.datamapIos,
            dynamic: savedData?.dynamic,
            finalUrl: savedData?.finalUrl,
            keyfield: savedData?.keyfield,
            params: savedData?.params,
            passwordSivex: savedData?.passwordSivex,
            photoUrl: savedData?.photoUrl,
            profileUrl: savedData?.profileUrl,
            sivexUrl: savedData?.sivexUrl,
            stepOne: savedData?.stepOne,
            stepTwo: savedData?.stepTwo,
            url: savedData?.url,
            userSivex: savedData?.userSivex,
            wallet: savedData?.wallet,
            photoUser: savedData?.photoUser,
            photoApiUrl: savedData?.photoApiUrl,
            photoPassword: savedData?.photoPassword,
        }
    });

    const onSubmit = (data, _) => {
        setLoading(true);
        const dataRequest = {
            id: data?.id,
            uid: data?.uid,
            cognitoUrl: data?.cognitoUrl,
            datamapAndroid: data?.datamapAndroid,
            datamapIos: data?.datamapIos,
            dynamic: data?.dynamic,
            finalUrl: data?.finalUrl,
            keyfield: data?.keyfield,
            params: data?.params,
            passwordSivex: data?.passwordSivex,
            photoUrl: data?.photoUrl,
            profileUrl: data?.profileUrl,
            sivexUrl: data?.sivexUrl,
            stepOne: data?.stepOne,
            stepTwo: data?.stepTwo,
            url: data?.url,
            userSivex: data?.userSivex,
            wallet: data?.wallet,
            photoUser: data?.photoUser,
            photoPassword: data?.photoPassword,
            photoApiUrl: data?.photoApiUrl,
        };
        if (!editMode) {
            //Save
            return confGlobalService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;
            if (JSON.stringify(savedData) === JSON.stringify(dataRequest)) {
                return showToastCustom(info, infoMsg);
            }

            return confGlobalService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true)
    }

    const resetForm = () => {
        setSavedData(null);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    return (
        <Card>
            {loading ? showLoader() : null}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="UdnId">Id</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="uidUdn">UID Firebase</Label>
                                <Input type="id" name="uid" id="uid"
                                       disabled
                                       value={editMode ? savedData?.uid : ''}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="userSivex">Usuario sivex</Label>
                                <Input type="text" name="userSivex"
                                       placeholder="Usuario"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.userSivex ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="userSivex" component="div" className="invalid-feedback" />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="passwordSivex">Contraseña</Label>
                                <Input type="passwordSivex" name="passwordSivex"
                                       placeholder="Contraseña"
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.passwordSivex ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="passwordSivex" component="div" className="invalid-feedback" />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="datamapAndroid">Datamap Android</Label>
                                <Input type="text" name="datamapAndroid"
                                       placeholder="Datamap Android"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="datamapIos">Datamap IOS</Label>
                                <Input type="text" name="datamapIos"
                                       placeholder="Datamap Android"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="dynamic">Dinamic</Label>
                                <Input type="text" name="dynamic"
                                       placeholder="Usuario"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="keyfield">Key</Label>
                                <Input type="text" name="keyfield"
                                       placeholder="Key"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="params">Params</Label>
                                <Input type="text" name="params"
                                       placeholder="Params"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="wallet">Wallet</Label>
                                <Input type="number" name="wallet"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="url">URL</Label>
                                <Input type="text" name="url"
                                       placeholder="Url"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="stepOne">stepOne</Label>
                                <Input type="text" name="stepOne"
                                       placeholder="stepOne"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="stepTwo">stepTwo</Label>
                                <Input type="text" name="stepTwo"
                                       placeholder="stepTwo"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="finalUrl">finalUrl</Label>
                                <Input type="text" name="finalUrl"
                                       placeholder="finalUrl"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="sivexUrl">Sivex Url</Label>
                                <Input type="text" name="sivexUrl"
                                       placeholder="Sivex Url"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="photoUrl">Photo Url</Label>
                                <Input type="text" name="photoUrl"
                                       placeholder="Photo Url"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="cognitoUrl">Cognito Url</Label>
                                <Input type="text" name="cognitoUrl"
                                       placeholder="Cognito Url"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="photoApiUrl">Photo Api Url</Label>
                                <Input type="text" name="photoApiUrl"
                                       placeholder="Photo Api Url"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label htmlFor="profileUrl">Profile Url</Label>
                                <Input type="text" name="profileUrl"
                                       placeholder="Profile Url"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="photoUser">Photo Usuario</Label>
                                <Input type="text" name="photoUser"
                                       placeholder="Photo Usuario"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label htmlFor="photoPassword">Photo Contraseña</Label>
                                <Input type="password" name="photoPassword"
                                       placeholder="Photo Contraseña"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                    </Row>

                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={props.toggleParent}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}